// The active support-impersonation context, set once at boot by
// initializeImpersonation. Kept dependency-free so feature gates can read it
// without importing axios interceptors or the shared query client (SKE-5103).
export interface StaffImpersonation {
  id: string;
  actorId: string;
  effectiveUserId: string;
  expiresAt: number;
  email: string;
  reason?: string;
}

let current: StaffImpersonation | null = null;

export const getImpersonation = () => current;

export function setImpersonation(value: StaffImpersonation | null) {
  current = value;
}
